
import  { ReactComponent as IconDelete }        from '../../assets/Icons/icon-delete.svg'
import  { ReactComponent as IconEdit }          from '../../assets/Icons/icon-edit.svg'
import vazio                                    from '../../assets/caixa-vazia.png'
import '../../styles/Table.css';
import '../../styles/main.css';
import '../../styles/JustificationPage.css'
import { useUser }                              from '../../contexts/UserContext.js';
import { findPermission }                       from '../../utils/UserPermissionUtils.js';
const __formatCollorText = (wagons) => {
  
	if (wagons > 0) {
	  return <span className="text-green-500">{wagons.toLocaleString('pt-BR')}</span>;
	}
	if (wagons < 0) {
	  return <span className="text-red-500">{wagons.toLocaleString('pt-BR')}</span>;
	}
	return <span className="text-gray-500">--</span>;
  };

export default function JustificationTable({tableRows, onEditRow, onDeleteRow}){

    const {userData} = useUser()

    return (<>
    
        {tableRows.length > 0?
            
            <table className='table-pattern-sistem w-[100%] borda-cinza mt-4'> 
                
                <thead>

                    <tr>

                        <th></th>
                        <th className="!text-left"  >Motivo     </th>
                        <th className="!text-center">Vagões     </th>
                        <th className="!text-left"  >Descrição  </th>
                        <th className="!text-center">           </th>
                        
                        {findPermission(userData, "Editar Justificativas") && (<>
                            
                            <th className="!text-center">           </th>
                            <th className="!text-center">           </th>
                        
                        </>)}
                        
                    </tr>

                </thead>

                <tbody>
                    
                    {tableRows.map((data)=>(
    
                        <tr key={data.id}>
                            
                            <td>{data.id}</td>
                            
                            <td>{data.ownerCategory.name}</td>
                            
                            <td className='!text-center'>{__formatCollorText(data.wagons)}</td>

                            <td>
                                <div className="flex flex-col">
                                    <p>{data.description}</p>
                                </div>
                            </td>
                            
                            <td>
                                <div className="flex flex-col">
                                    <strong>Autor:</strong>
                                    <p>{data.ownerUser.fullName}</p>
                                </div>
                            </td>
                            
                            {findPermission(userData, "Editar Justificativas") && (
                                <>
                                    <td className="icon-gray" onClick={() => onEditRow(data.id)}>
                                        <IconEdit/>
                                    </td>
                                    
                                    <td className="icon-gray" onClick={() => onDeleteRow(data.id)}>
                                        <IconDelete/>
                                    </td>

                                </>
                            )}

                        </tr>
                    ))}   

                </tbody>
            
            </table>

            : 

            <div className=' flex flex-col w-[100%] items-center justify-center pt-[10px]'>
                <img className="" alt="Vazio" width="150px" height="150px" src={vazio} />
                <h2 className='text-[#004B9B]'>Não há dados.</h2>
            </div>
        }
        </>)

}